module.exports = __webpack_public_path__ + "img/craftBannerCarport.ab57424.webp";